import { IExperiment } from '../../types/experiments';

const defaultState: IExperiment[] = [];

export function experimentsReducer(state: IExperiment[] = defaultState): IExperiment[] {
  return state;
}
